const revenueTargetOptions = [
  {
    value: 'revenueTarget.none',
    amount: null
  },
  {
    value: 'revenueTarget.oneThousand',
    amount: 1000
  },
  {
    value: 'revenueTarget.fiveThousand',
    amount: 5000
  },
  {
    value: 'revenueTarget.tenThousand',
    amount: 10000
  },
  {
    value: 'revenueTarget.hundredThousand',
    amount: 100000
  },
  {
    value: 'revenueTarget.oneMillion',
    amount: 1000000
  },
  {
    value: 'revenueTarget.moreThanMillion',
    amount: 1000001
  }
];

export default revenueTargetOptions;
